const branchName = process.env.OT_PROTOCOLS_BRANCH
const branchSuffix = (name) => name === 'master' ? '' : `-${name}`
const appendBranchSuffix = (name) => encodeURIComponent(name + branchSuffix(process.env.OT_PROTOCOLS_BRANCH))

const createIframeListener = (iframeId) => {
  // Listen to message from child window and reset iframe height continually
  return window.addEventListener('message', e => {
    const origin = e.origin || e.originalEvent.origin // Chrome support (uses originalEvent)

    console.log('parent received message!:  ', e.data.type, {data: e.data, origin, e})

    const iframe = document.getElementById(iframeId)
    if (iframe === null) {
      console.log('No iframe found with id', iframeId)
    } else {
      if (e.data.type === 'SCROLL_TO_TOP') {
        const iframeYPos = document.getElementById('embedded-app').getBoundingClientRect().top
        const navHeight = document.getElementById('nav').offsetHeight
        window.scrollTo(0, iframeYPos + window.pageYOffset - navHeight)
      }
    }
  }, false)
}

export default {
  branchSuffix,
  appendBranchSuffix,
  branchName,
  createIframeListener
}



// WEBPACK FOOTER //
// ./src/util.js